import { render, staticRenderFns } from "./Triggers.vue?vue&type=template&id=95cc1342&scoped=true"
import script from "./Triggers.vue?vue&type=script&lang=js"
export * from "./Triggers.vue?vue&type=script&lang=js"
import style0 from "./Triggers.vue?vue&type=style&index=0&id=95cc1342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95cc1342",
  null
  
)

export default component.exports